import { Container } from "react-bootstrap";

export const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-glow" />
      <Container>
        <div className="footer-inner">
          <h3 className="footer-name">Faria Habib</h3>
          <p className="footer-quote">
            "Building technology that works for everyone — especially those often overlooked."
          </p>
          <div className="footer-divider" />
          <p className="footer-copy">
            © {new Date().getFullYear()} Faria Habib · Designed & Built with ♥
          </p>
        </div>
      </Container>
    </footer>
  );
};
